import {Component, OnInit} from '@angular/core';
import {StateService} from "@uirouter/core";

import {ParametersService, SubtitlesService, ZonesService} from "../../core";

@Component({
    selector: 'valve',
    templateUrl: './valve.component.html',
    styleUrls: ['./valve.component.scss']
})
export class ValveComponent implements OnInit {
    constructor(
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
    ) {
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.zones.setOverflow();
    }
}
